import { useMutation } from "@tanstack/react-query";
import { ViewPdf } from "Services/API/VisitPdf.service";

export const useNotePdfView = () => {
  const mutation = useMutation({
    mutationFn: async (pdfId) => {
      const url = await ViewPdf(pdfId);
      return url;
    },
    onSuccess: (url) => {
      window.open(url, "_blank", "noopener,noreferrer");
    },
  });

  return {
    viewPdf: mutation.mutate,
    isLoading: mutation.isLoading,
    error: mutation.error,
    reset: mutation.reset,
  };
};
